import { render } from "./MainLayout.vue?vue&type=template&id=5d37d2dc"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\PHPStormServer\\s_hmel\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__